namespace Matrix.Indexation {
    export interface FactIndexPriceForm {
        IndexationProfileKey: Serenity.IntegerEditor;
        IndexKey: Serenity.IntegerEditor;
        PriceTypeCode: Serenity.StringEditor;
        PriceDate: Serenity.DateEditor;
        IndexPrice: Serenity.DecimalEditor;
        SourceCode: Serenity.StringEditor;
        IndexPriceCurrency: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class FactIndexPriceForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.FactIndexPrice';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FactIndexPriceForm.init)  {
                FactIndexPriceForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(FactIndexPriceForm, [
                    'IndexationProfileKey', w0,
                    'IndexKey', w0,
                    'PriceTypeCode', w1,
                    'PriceDate', w2,
                    'IndexPrice', w3,
                    'SourceCode', w1,
                    'IndexPriceCurrency', w1,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
